
cc.Class({
    extends: cc.Component,

    properties: {
        kXsmall: 1,
        kYsmall: 1,
        kX: 1,
        kY: 1,
        kXbig: 0,
        kYbig: 0,
        maxRatio: 1,
        minRatio: 0,
        ignorePosition: true,
        deltaX: 0,
        deltaY: 0,
        ignorePositionMin: true,
        deltaXMin: 0,
        deltaYMin: 0,
        ignorePositionMax: true,
        deltaXMax: 0,
        deltaYMax: 0,
        useParentScale: true,
        isDebug: false
    },

    // TODO handle case when object changes its original position
    onLoad () {
        this.resizeManager = cc.find('ResizeManager').getComponent('ResizeManager');

        if (!this.resizeManager) {
            cc.warn('Cannot find resize manager');
            return;
        }

        this.originScale = { x: this.node.scaleX, y: this.node.scaleY };
        this.originX = this.node.x;
        this.originY = this.node.y;

        this.resizeManager.appendNode(this);

        // keep reference of the keys of properties to be able to update them runtime
        this.propertyKeys = [
            'kXsmall',
            'kYsmall',
            'kX',
            'kY',
            'kXbig',
            'kYbig',
            'maxRatio',
            'minRatio',
            'ignorePosition',
            'deltaX',
            'deltaY',
            'ignorePositionMin',
            'deltaXMin',
            'deltaYMin',
            'ignorePositionMax',
            'deltaXMax',
            'deltaYMax',
            'originX',
            'originY',
            'useParentScale'
        ];
    },

    onDestroy () {
        if (this.resizeManager) {
            this.resizeManager.removeNode(this);
        }
    },

    onEnable () {
        if (this.resizeManager) {
            this.resizeManager.requestViewResize(this);
        }
    },

    /**
     * Runtime coefficient update
     * @param {Object} params the object wchich holds coefficients to update
     */
    updateCoefficients (params) {
        if (!params || typeof params !== 'object') {
            cc.warn('[ScaleController] updateCoefficient: wrong parameter to update coefficient');

            return;
        }

        this.propertyKeys.forEach((key) => {
            if (params.hasOwnProperty(key) && !isNaN(params[key])) {
                this[key] = params[key];
            }
        });

        this.resizeManager.requestViewResize(this);
    },

    onViewResize (ratio) {
        let scale;

        if (ratio < this.minRatio) {
            const origScale = this._getScaleByRatio(this.minRatio, this.originScale, this.kX, this.kY);
            const newRatio = ratio / this.minRatio;

            scale = this._getScaleByRatio(newRatio, origScale, this.kXsmall, this.kYsmall);
        } else if (ratio > this.maxRatio) {
            const origScale = this._getScaleByRatio(this.maxRatio, this.originScale, this.kX, this.kY);
            const newRatio = ratio / this.maxRatio;

            scale = this._getScaleByRatio(newRatio, origScale, this.kXbig, this.kYbig);
        } else {
            scale = this._getScaleByRatio(ratio, this.originScale, this.kX, this.kY);
        }

        this._updatePosition(ratio);

        if (this.useParentScale) {
            this.node.setScale(scale.x * (1 / this.node.parent.scaleX) ,
                scale.y * (1 / this.node.parent.scaleY));
        } else {
            this.node.setScale(scale.x, scale.y);
        }

        if (this.isDebug) {
            cc.log(`SCExt:[${  this.node.name  }] ${  this.node.scaleX  } ${  this.node.parent.scaleX}`);
        }
    },

    // eslint-disable-next-line max-statements
    _updatePosition (ratio) {
        let newX; let newY;

        newX = this.originX;
        newY = this.originY;

        if (!this.ignorePosition) {
            if (ratio < this.minRatio && !this.ignorePositionMin) {
                const pos = this._getScaledPosition(this.minRatio, this.maxRatio, this.deltaX, this.deltaY);
                const minPos = this._getScaledPosition(ratio, this.minRatio, this.deltaXMin, this.deltaYMin);

                newX = Math.abs(minPos.x - pos.x) + minPos.x;
                newY = Math.abs(minPos.y - pos.y) + minPos.y;

            } else if (ratio > this.maxRatio && !this.ignorePositionMax) {
                const pos = this._getScaledPosition(this.minRatio, this.maxRatio, this.deltaX, this.deltaY);
                const minPos = this._getScaledPosition(ratio, this.maxRatio, this.deltaXMax, this.deltaYMax);

                newX = Math.abs(minPos.x - pos.x) + minPos.x;
                newY = Math.abs(minPos.y - pos.y) + minPos.y;

            } else if (ratio < this.maxRatio) {
                const pos = this._getScaledPosition(ratio, this.maxRatio, this.deltaX, this.deltaY);

                newX = pos.x;
                newY = pos.y;
            }
        }

        this.node.x = newX;
        this.node.y = newY;

        if (this.isDebug) {
            cc.log(`SCExt:[${  this.node.name  }] originY:${  this.originY  } newY:${  newY}`);
        }
    },

    _getScaledPosition (ratio, sourceRatio, kX, kY) {
        let newX = 0; let newY = 0;
        const coef = Math.abs(((sourceRatio - ratio) / sourceRatio));

        if (coef) {
            newX = this.originX - coef * kX;
            newY = this.originY - coef * kY;
        } else {
            newX = this.originX;
            newY = this.originY;
        }

        return { x: newX, y: newY };
    },

    _getScaleByRatio (ratio, originalScale, kX, kY) {
        let scaleX;
        let scaleY;

        if (originalScale.x > 0) {
            scaleX = originalScale.x - (1 - ratio) * kX * originalScale.x;
        } else {
            scaleX = originalScale.x + (1 - ratio) * kX * originalScale.x;
        }

        if (originalScale.y > 0) {
            scaleY = originalScale.x - (1 - ratio) * kY * originalScale.y;
        } else {
            scaleY = originalScale.y + (1 - ratio) * kY * originalScale.y;
        }

        return { x: scaleX, y: scaleY };
    }
});
